import {

    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    CLEAR_ERRORS,


    MANUAL_REGISTER_REQUEST,
    MANUAL_REGISTER_SUCCESS,
    MANUAL_REGISTER_RESET,
    MANUAL_REGISTER_FAIL,

    VERIFY_TIME_REQUEST,
    VERIFY_TIME_SUCCESS,
    VERIFY_TIME_FAIL,

    RESEND_EMAIL_REQUEST,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAIL,


    VERIFY_EMAIL_REQUEST,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAIL,




    LOGOUT_SUCCESS,
    LOGOUT_FAIL,


    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,


    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,


    FORGET_PASSWORD_REQUEST,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAIL,


    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,


    ALL_USERS_REQUEST,
    ALL_USERS_SUCCESS,
    ALL_USERS_FAIL,


    UPDATE_USER_STATUS_REQUEST,
    UPDATE_USER_STATUS_SUCCESS,
    UPDATE_USER_STATUS_RESET,
    UPDATE_USER_STATUS_FAIL,




    UPDATE_AVATAR_REQUEST,
    UPDATE_AVATAR_SUCCESS,
    UPDATE_AVATAR_FAIL,



    CLEAR_MESSAGES,
    REGISTER_USER_RESET,
    RESEND_EMAIL_RESET,
    FORGET_PASSWORD_RESET,
    UPDATE_AVATAR_RESET,




    INVITE_USER_REQUEST,
    INVITE_USER_SUCCESS,
    INVITE_USER_RESET,
    INVITE_USER_FAIL,


    SAVE_SETTINGS_REQUEST,
    SAVE_SETTINGS_SUCCESS,
    SAVE_SETTINGS_RESET,
    SAVE_SETTINGS_FAIL,


    LOAD_SETTINGS_REQUEST,
    LOAD_SETTINGS_SUCCESS,
    LOAD_SETTINGS_FAIL,



    CREATE_CATEGORY_REQUEST,
    CREATE_CATEGORY_SUCCESS,
    CREATE_CATEGORY_RESET,
    CREATE_CATEGORY_FAIL,

    TOGGLE_CATEGORY_REQUEST,
    TOGGLE_CATEGORY_SUCCESS,
    TOGGLE_CATEGORY_RESET,
    TOGGLE_CATEGORY_FAIL,

    ALL_CATEGORIES_REQUEST,
    ALL_CATEGORIES_SUCCESS,
    ALL_CATEGORIES_FAIL,


    CREATE_PRODUCT_TYPE_REQUEST,
    CREATE_PRODUCT_TYPE_SUCCESS,
    CREATE_PRODUCT_TYPE_RESET,
    CREATE_PRODUCT_TYPE_FAIL,

    UPDATE_PRODUCT_TYPE_REQUEST,
    UPDATE_PRODUCT_TYPE_SUCCESS,
    UPDATE_PRODUCT_TYPE_FAIL,
    UPDATE_PRODUCT_TYPE_RESET,

    TOGGLE_PRODUCT_TYPE_REQUEST,
    TOGGLE_PRODUCT_TYPE_SUCCESS,
    TOGGLE_PRODUCT_TYPE_RESET,
    TOGGLE_PRODUCT_TYPE_FAIL,

    ALL_PRODUCT_TYPES_REQUEST,
    ALL_PRODUCT_TYPES_SUCCESS,
    ALL_PRODUCT_TYPES_FAIL,

    ADD_DETAILS_REQUEST,
    ADD_DETAILS_SUCCESS,
    ADD_DETAILS_RESET,
    ADD_DETAILS_FAIL,



    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_RESET,
    CHANGE_PASSWORD_FAIL,


    ALL_ADMINS_REQUEST,
    ALL_ADMINS_SUCCESS,
    ALL_ADMINS_FAIL,


    VERIFY_TOKEN_REQUEST,
    VERIFY_TOKEN_SUCCESS,
    VERIFY_TOKEN_FAIL,


    ALL_PMM_REQUEST,
    ALL_PMM_SUCCESS,
    ALL_PMM_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,

    ALLOW_EDITING_REQUEST,
    ALLOW_EDITING_SUCCESS,
    ALLOW_EDITING_RESET,
    ALLOW_EDITING_FAIL,

    CHANGE_ADMIN_REQUEST,
    CHANGE_ADMIN_SUCCESS,
    CHANGE_ADMIN_RESET,
    CHANGE_ADMIN_FAIL,



    ALL_INVITES_REQUEST,
    ALL_INVITES_SUCCESS,
    ALL_INVITES_FAIL,


    CREATE_BLOCKED_EMAIL_REQUEST,
    CREATE_BLOCKED_EMAIL_SUCCESS,
    CREATE_BLOCKED_EMAIL_FAIL,
    CREATE_BLOCKED_EMAIL_RESET,

    ALL_BLOCKED_EMAIL_REQUEST,
    ALL_BLOCKED_EMAIL_SUCCESS,
    ALL_BLOCKED_EMAIL_FAIL,

    DELETE_BLOCKED_EMAIL_REQUEST,
    DELETE_BLOCKED_EMAIL_SUCCESS,
    DELETE_BLOCKED_EMAIL_RESET,
    DELETE_BLOCKED_EMAIL_FAIL,


    CREATE_PRODUCT_MARKET_REQUEST,
    CREATE_PRODUCT_MARKET_SUCCESS,
    CREATE_PRODUCT_MARKET_RESET,
    CREATE_PRODUCT_MARKET_FAIL,

    TOGGLE_PRODUCT_MARKET_REQUEST,
    TOGGLE_PRODUCT_MARKET_SUCCESS,
    TOGGLE_PRODUCT_MARKET_RESET,
    TOGGLE_PRODUCT_MARKET_FAIL,

    ALL_PRODUCT_MARKETS_REQUEST,
    ALL_PRODUCT_MARKETS_SUCCESS,
    ALL_PRODUCT_MARKETS_FAIL,

    ALL_PENDING_USERS_REQUEST,
    ALL_PENDING_USERS_SUCCESS,
    ALL_PENDING_USERS_FAIL,




    APPROVE_USER_REQUEST,
    APPROVE_USER_SUCCESS,
    APPROVE_USER_RESET,
    APPROVE_USER_FAIL,



    CONTACT_REQUEST,
    CONTACT_SUCCESS,
    CONTACT_RESET,
    CONTACT_FAIL,

    UPDATE_CATEGORY_REQUEST,
    UPDATE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_RESET,
    UPDATE_CATEGORY_FAIL,

    DELETE_CATEGORY_REQUEST,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_RESET,
    DELETE_CATEGORY_FAIL,

    UPDATE_PRODUCT_MARKET_REQUEST,
    UPDATE_PRODUCT_MARKET_SUCCESS,
    UPDATE_PRODUCT_MARKET_RESET,
    UPDATE_PRODUCT_MARKET_FAIL,

    DELETE_PRODUCT_MARKET_REQUEST,
    DELETE_PRODUCT_MARKET_SUCCESS,
    DELETE_PRODUCT_MARKET_RESET,
    DELETE_PRODUCT_MARKET_FAIL,
    DELETE_PRODUCT_TYPE_REQUEST,
    DELETE_PRODUCT_TYPE_SUCCESS,
    DELETE_PRODUCT_TYPE_RESET,
    DELETE_PRODUCT_TYPE_FAIL,
    ADMIN_UPDATE_USER_CREDENTIALS_REQUEST,
    ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS,
    ADMIN_UPDATE_USER_CREDENTIALS_RESET,
    ADMIN_UPDATE_USER_CREDENTIALS_FAIL,
} from "../constants/userConstant"

export const RegisterReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case REGISTER_USER_REQUEST:
        case LOGIN_REQUEST:
        case CREATE_BLOCKED_EMAIL_REQUEST:
        case DELETE_BLOCKED_EMAIL_REQUEST:
        case MANUAL_REGISTER_REQUEST:

            return {
                loading: true,
            }

        case REGISTER_USER_SUCCESS:
        case LOGIN_SUCCESS:
        case CREATE_BLOCKED_EMAIL_SUCCESS:
        case DELETE_BLOCKED_EMAIL_SUCCESS:
        case MANUAL_REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case REGISTER_USER_FAIL:
        case LOGIN_FAIL:
        case CREATE_BLOCKED_EMAIL_FAIL:
        case DELETE_BLOCKED_EMAIL_FAIL:
        case MANUAL_REGISTER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case REGISTER_USER_RESET:
        case CREATE_BLOCKED_EMAIL_RESET:
        case DELETE_BLOCKED_EMAIL_RESET:
        case MANUAL_REGISTER_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const contactReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case CONTACT_REQUEST:

            return {
                loading: true,
            }

        case CONTACT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case CONTACT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case CONTACT_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const verifyTokenReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case VERIFY_TOKEN_REQUEST:
            return {
                loading: true,
            }

        case VERIFY_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                invite: action.payload.invite
            }

        case VERIFY_TOKEN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                invite: null // optional: clear old message
            }


        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const verifyTimeReducer = (state = { time: {} }, action) => {

    switch (action.type) {
        case VERIFY_TIME_REQUEST:
            return {
                loading: true,
            }

        case VERIFY_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                expiryTime: action.payload
            }

        case VERIFY_TIME_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                expireyTime: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const resendEmailReducer = (state = { email: {} }, action) => {

    switch (action.type) {
        case RESEND_EMAIL_REQUEST:
            return {
                loading: true,
            }

        case RESEND_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                expireTime: action.payload.expireTime
            }

        case RESEND_EMAIL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                expireyTime: null, // optional: clear old message
                message: null // optional: clear old message
            }
        case RESEND_EMAIL_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const verifyEmailReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case VERIFY_EMAIL_REQUEST:
        case LOAD_USER_REQUEST:
        case RESET_PASSWORD_REQUEST:
            return {
                loading: true,
            }

        case VERIFY_EMAIL_SUCCESS:
        case LOAD_USER_SUCCESS:
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                user: action.payload.user,
                isAuthenticated: true,
                isLoggedout: false
            }

        case VERIFY_EMAIL_FAIL:
        case LOAD_USER_FAIL:
        case RESET_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
                user: null, // optional: clear old message
                isAuthenticated: false,
                isLoggedout: true
            }
        case LOGOUT_SUCCESS:
            return {
                loading: false,
                user: null, // optional: clear old message
                isAuthenticated: false, // optional: clear old message
                isLoggedout: true
            }
        case LOGOUT_FAIL:
            return {
                loading: false,
                user: null, // optional: clear old message
                isAuthenticated: false, // optional: clear old message
                isLoggedout: false
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        case CLEAR_MESSAGES:

            return {
                ...state,
                message: null,
            }
        default:
            return state;
    }

}
export const forgotPasswordReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case FORGET_PASSWORD_REQUEST:
            return {
                loading: true,
            }

        case FORGET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case FORGET_PASSWORD_FAIL:
            return {
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case FORGET_PASSWORD_RESET:
            return {
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const allUsersReducer = (state = { users: {} }, action) => {

    switch (action.type) {
        case ALL_USERS_REQUEST:
            return {
                loading: true,
            }

        case ALL_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                users: action.payload.users
            }

        case ALL_USERS_FAIL:
            return {
                loading: false,
                error: action.payload,
                users: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const allpendingUsersReducer = (state = { users: {} }, action) => {

    switch (action.type) {
        case ALL_PENDING_USERS_REQUEST:
            return {
                loading: true,
            }

        case ALL_PENDING_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                users: action.payload.users,
                totalUsers: action.payload.totalUsers,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
            }

        case ALL_PENDING_USERS_FAIL:
            return {
                loading: false,
                error: action.payload,
                users: null, // optional: clear old message
                totalUsers: null,
                totalPages: null,
                currentPage: null,
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const allBlockedEmailsReducer = (state = { users: {} }, action) => {

    switch (action.type) {
        case ALL_BLOCKED_EMAIL_REQUEST:
            return {
                loading: true,
            }

        case ALL_BLOCKED_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                blockedEmails: action.payload.blockedEmails,
                totalblockedEmails: action.payload.totalblockedEmails,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
            }

        case ALL_BLOCKED_EMAIL_FAIL:
            return {
                loading: false,
                error: action.payload,
                users: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const allowEditingReducer = (state = { users: {} }, action) => {

    switch (action.type) {
        case ALLOW_EDITING_REQUEST:
        case CHANGE_ADMIN_REQUEST:

            return {
                loading: true,
            }

        case ALLOW_EDITING_SUCCESS:
        case CHANGE_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case ALLOW_EDITING_FAIL:
        case CHANGE_ADMIN_FAIL:
            return {
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case ALLOW_EDITING_RESET:
        case CHANGE_ADMIN_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}








export const updateAvatarReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case UPDATE_AVATAR_REQUEST:
            return {
                loading: true,
            }

        case UPDATE_AVATAR_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case UPDATE_AVATAR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        case UPDATE_AVATAR_RESET:

            return {
                ...state,
                message: null,
            }
        default:
            return state;
    }

}





export const inviteUserReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case INVITE_USER_REQUEST:
        case SAVE_SETTINGS_REQUEST:
        case ADD_DETAILS_REQUEST:
        case CHANGE_PASSWORD_REQUEST:
        case UPDATE_USER_STATUS_REQUEST:
        case APPROVE_USER_REQUEST:
        case ADMIN_UPDATE_USER_CREDENTIALS_REQUEST:
            return {
                loading: true,
            }

        case INVITE_USER_SUCCESS:
        case SAVE_SETTINGS_SUCCESS:
        case ADD_DETAILS_SUCCESS:
        case CHANGE_PASSWORD_SUCCESS:
        case UPDATE_USER_STATUS_SUCCESS:
        case APPROVE_USER_SUCCESS:
        case ADMIN_UPDATE_USER_CREDENTIALS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case INVITE_USER_FAIL:
        case SAVE_SETTINGS_FAIL:
        case ADD_DETAILS_FAIL:
        case CHANGE_PASSWORD_FAIL:
        case UPDATE_USER_STATUS_FAIL:
        case APPROVE_USER_FAIL:
        case ADMIN_UPDATE_USER_CREDENTIALS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case INVITE_USER_RESET:
        case SAVE_SETTINGS_RESET:
        case ADD_DETAILS_RESET:
        case CHANGE_PASSWORD_RESET:
        case UPDATE_USER_STATUS_RESET:
        case APPROVE_USER_RESET:
        case ADMIN_UPDATE_USER_CREDENTIALS_RESET:
            return {
                ...state,
                loading: false,
                success: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }


        default:
            return state;
    }

}
export const loadSettingsReducer = (state = { settings: {} }, action) => {

    switch (action.type) {
        case LOAD_SETTINGS_REQUEST:
            return {
                loading: true,
                settings: null
            }
        case LOAD_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                settings: action.payload.settings
            }
        case LOAD_SETTINGS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case CLEAR_ERRORS:
            return {
                loading: false,
                error: null,
            }

        default:
            return state;
    }

}

export const createCategoryReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case CREATE_CATEGORY_REQUEST:
        case TOGGLE_CATEGORY_REQUEST:
        case UPDATE_CATEGORY_REQUEST:
        case DELETE_CATEGORY_REQUEST:
            return {
                loading: true,
            }

        case CREATE_CATEGORY_SUCCESS:
        case TOGGLE_CATEGORY_SUCCESS:
        case UPDATE_CATEGORY_SUCCESS:
        case DELETE_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case CREATE_CATEGORY_FAIL:
        case TOGGLE_CATEGORY_FAIL:
        case UPDATE_CATEGORY_FAIL:
        case DELETE_CATEGORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case CREATE_CATEGORY_RESET:
        case TOGGLE_CATEGORY_RESET:
        case UPDATE_CATEGORY_RESET:
        case DELETE_CATEGORY_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }


        default:
            return state;
    }

}
export const allCategoriesReducers = (state = { category: {} }, action) => {

    switch (action.type) {
        case ALL_CATEGORIES_REQUEST:
            return {
                loading: true,
            }

        case ALL_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                categories: action.payload.categories
            }

        case ALL_CATEGORIES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                categories: null // optional: clear old message
            }
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            }


        default:
            return state;
    }

}

export const createProductTypeReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PRODUCT_TYPE_REQUEST:
        case TOGGLE_PRODUCT_TYPE_REQUEST:
        case UPDATE_PRODUCT_TYPE_REQUEST:
        case DELETE_PRODUCT_TYPE_REQUEST:

            return { loading: true };

        case CREATE_PRODUCT_TYPE_SUCCESS:
        case TOGGLE_PRODUCT_TYPE_SUCCESS:
        case UPDATE_PRODUCT_TYPE_SUCCESS:
        case DELETE_PRODUCT_TYPE_SUCCESS:
            return { ...state, loading: false, success: true, message: action.payload.message };

        case CREATE_PRODUCT_TYPE_FAIL:
        case TOGGLE_PRODUCT_TYPE_FAIL:
        case UPDATE_PRODUCT_TYPE_FAIL:
        case DELETE_PRODUCT_TYPE_FAIL:
            return { ...state, loading: false, error: action.payload, message: null };

        case CREATE_PRODUCT_TYPE_RESET:
        case TOGGLE_PRODUCT_TYPE_RESET:
        case UPDATE_PRODUCT_TYPE_RESET:
        case DELETE_PRODUCT_TYPE_RESET:
            return { ...state, loading: false, message: null };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};

export const allProductTypesReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_PRODUCT_TYPES_REQUEST:
            return { loading: true };

        case ALL_PRODUCT_TYPES_SUCCESS:
            return { ...state, loading: false, success: true, productTypes: action.payload.productTypes };

        case ALL_PRODUCT_TYPES_FAIL:
            return { ...state, loading: false, error: action.payload, productTypes: null };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};

export const allAdminReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_ADMINS_REQUEST:
            return { loading: true };

        case ALL_ADMINS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                admins: action.payload.admins,
                totalAdmins: action.payload.totalAdmins,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                blockedUsers: action.payload.blockedUsers,
                tempBlockedUsers: action.payload.tempBlockedUsers,

            };

        case ALL_ADMINS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                productTypes: null
            };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};
export const allPmmReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_PMM_REQUEST:
            return { loading: true };

        case ALL_PMM_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                PMMs: action.payload.PMMs,
                totalPMM: action.payload.totalPMM,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                blockedUsers: action.payload.blockedUsers,
                tempBlockedUsers: action.payload.tempBlockedUsers,

            };

        case ALL_PMM_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                PMMs: null
            };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};
export const userDetailsReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_DETAILS_REQUEST:
            return { loading: true };

        case USER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                user: action.payload.user,

            };

        case USER_DETAILS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                user: null
            };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};
export const allInviteReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_INVITES_REQUEST:
            return { loading: true };

        case ALL_INVITES_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                userInvites: action.payload.userInvites,
                totalPages: action.payload.totalPages,
            };

        case ALL_INVITES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                PMMs: null
            };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};


export const createProductMarktReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PRODUCT_MARKET_REQUEST:
        case TOGGLE_PRODUCT_MARKET_REQUEST:
        case UPDATE_PRODUCT_MARKET_REQUEST:
        case DELETE_PRODUCT_MARKET_REQUEST:
            return { loading: true };

        case CREATE_PRODUCT_MARKET_SUCCESS:
        case TOGGLE_PRODUCT_MARKET_SUCCESS:
        case UPDATE_PRODUCT_MARKET_SUCCESS:
        case DELETE_PRODUCT_MARKET_SUCCESS:
            return { ...state, loading: false, success: true, message: action.payload.message };

        case CREATE_PRODUCT_MARKET_FAIL:
        case TOGGLE_PRODUCT_MARKET_FAIL:
        case UPDATE_PRODUCT_MARKET_FAIL:
        case DELETE_PRODUCT_MARKET_FAIL:
            return { ...state, loading: false, error: action.payload, message: null };

        case CREATE_PRODUCT_MARKET_RESET:
        case TOGGLE_PRODUCT_MARKET_RESET:
        case UPDATE_PRODUCT_MARKET_RESET:
        case DELETE_PRODUCT_MARKET_RESET:
            return { ...state, loading: false, message: null };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};

export const allProductMarketsReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_PRODUCT_MARKETS_REQUEST:
            return { loading: true };

        case ALL_PRODUCT_MARKETS_SUCCESS:
            return { ...state, loading: false, success: true, productMarkets: action.payload.productMarkets };

        case ALL_PRODUCT_MARKETS_FAIL:
            return { ...state, loading: false, error: action.payload, productMarkets: null };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};


// uploadSlice.js


const initialState = {
    loading: false,
    progress: 0,
    current: 0,
    total: 0,
};

export const uploadReducer = (state = initialState, action) => {
    switch (action.type) {
        case "UPLOAD_START":
            return { loading: true, progress: 0 };

        case "UPLOAD_PROGRESS":
            return {
                ...state,
                progress: action.payload >= 90 ? 90 : action.payload
            };

        case "UPLOAD_STEP":
            return {
                ...state,
                current: action.payload.current,
                total: action.payload.total,
            };

        case "UPLOAD_END":
            return { loading: false, progress: 100 };

        case "UPLOAD_RESET":
            return initialState;

        default:
            return state;
    }
};